export default __webpack_public_path__ + "static/media/english-to-turkish-logo.6793f0ad.png";